<template>
    <div class="floating-atrativo">
      <div v-if="form.auto_checkin" class="text-center w-100">
        AUTO CHECKIN
      </div>
      <div class="img-atrativo">
        <b-card style="margin-bottom: 0; box-shadow: none;" :title="`${form.atrativo.product_place_name}: ${form.atrativo.product_name}`" :img-src="logoUrl">
        </b-card>
      </div>
        <!-- "getProductImage(this.form.atrativo) -->
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import nodeService from '@/services/nodejs/index'
import { publicLogoSource } from '@/store/utils/placePublicData'

export default {
    name: 'AtrativoCard',

    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapGetters('booking', {
            form: 'getReservaForm',
            place_public_data: 'getPlacePublicData',
        }),

    },

    watch: {
        place_public_data: {
            deep: true,
            immediate: true,
            handler() {
                this.loadPlaceLogo()
            },
        },
    },

    data() {
        return {
            logoUrl: null,
            logoObjectUrl: null,
        }
    },

    methods: {
        ...mapActions('booking', [
            'bookingStoreCommit',
        ]),

        clearPlaceLogo() {
            if (this.logoObjectUrl) {
                URL.revokeObjectURL(this.logoObjectUrl)
                this.logoObjectUrl = null
            }
        },

        async loadPlaceLogo() {
            this.clearPlaceLogo()
            this.logoUrl = null
            const resolved = publicLogoSource(this.place_public_data)
            if (!resolved || !resolved.src) return
            if (resolved.type === 'url') {
                this.logoUrl = resolved.src
                return
            }
            try {
                const response = await nodeService.getFileByPath(resolved.src)
                const objectUrl = URL.createObjectURL(
                    new Blob([response.data], { type: response.data.type })
                )
                this.logoObjectUrl = objectUrl
                this.logoUrl = objectUrl
            } catch (error) {
                console.warn('Não foi possível carregar o logotipo do gestor:', error)
            }
        },

        getProductImage(product) {
            if(product.images && product.images.length > 0){
              const URL = product.images[0]
              if(URL){
                if(URL.indexOf('google.com') > 0){
                  var regex = /d\/(.*)\/view/g
                  var array_id = regex.exec(URL)
                  if(array_id && array_id[1]){
                      return `https://drive.google.com/thumbnail?id=${array_id[1]}&sz=w400`
                  }
                }else{
                  return URL
                }
              }
              return require('@/assets/img/j-logo.png')

            }
            return null
        },
    },

    beforeDestroy() {
        this.clearPlaceLogo()
    },

}
</script>

<style scoped>
.floating-atrativo {
width: fit-content;
max-width: 300px;
height: fit-content;
background: #ffffff;
border: 1px solid #DBDBDB;
border-radius: 12px;
padding-left: 15px;
padding-right: 15px;
padding-top: 10px;
padding-bottom: 15px;
margin-bottom: 20px;
margin-left: 15px;
}

.img-atrativo {
width: auto;
height: auto;
background: #FFF;;
border-radius: 12px;
padding-left: 5px;
padding-right: 5px;
padding-top: 5px;
}

.img-atrativo img, .card-img {
    max-width: 30% !important;
}


.card {
    display: flex;
    flex-direction: row;
    align-items: center
}
.card-body {
    padding: 0;
}

.card-title {
    margin-bottom: 0;
    margin-left: 20px;
}
@media screen and (max-width: 1250px) {
    .floating-atrativo {
        margin-right: 0;
        max-width: 300px;
    }
}

@media screen and (max-width: 870px) {
    .floating-atrativo {
        margin-left: 0;
        max-width: fit-content;
        padding: 0px;
    }
}



</style>
